import ArrowIcon from '@mui/icons-material/ArrowForward'
import { Box } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'

import { AdvancedDateTimeInput } from './AdvancedDateTimeInputs'
import { getISOFromDateTime, parseDateAsDateTime } from '../utils/dates'

export const AdvancedDatesFilter = ({
  source = ['timeline_start', 'timeline_end'],
  maxDateTime,
  maxDurationInDays,
  ...props
}) => {
  const { setValue } = useFormContext()

  const [startSource, endSource] = source
  const [startDate, endDate] = useWatch({ name: source })

  const handleDateChange = (newValue, changedSource) => {
    setValue(changedSource, newValue)
    if (!maxDurationInDays || !newValue) return

    const isStart = changedSource === startSource
    const otherSource = isStart ? endSource : startSource
    const otherValue = isStart ? endDate : startDate
    const parsedOtherDate = otherValue ? parseDateAsDateTime(otherValue) : null

    if (parsedOtherDate) {
      const parsedNewDate = parseDateAsDateTime(newValue)
      const durationInDays = parsedNewDate.diff(parsedOtherDate, 'days').days
      // Detect if start date comes after end date or end date comes before start date
      if ((isStart && durationInDays > 0) || (!isStart && durationInDays < 0)) {
        // We don't reset the other date if the new date is the same day as the other date
        if (
          parsedNewDate.year === parsedOtherDate.year &&
          parsedNewDate.month === parsedOtherDate.month &&
          parsedNewDate.day === parsedOtherDate.day
        ) {
          return
        }
        // Otherwise, we reset the other date
        setValue(otherSource, null)
      } else if (Math.abs(durationInDays) > maxDurationInDays) {
        // If the duration is greater than the maximum allowed duration, we adjust the other date
        const adjustedDate = isStart
          ? parsedNewDate.plus({ days: maxDurationInDays })
          : parsedNewDate.minus({ days: maxDurationInDays })
        setValue(otherSource, getISOFromDateTime(adjustedDate))
      }
    }
  }

  return (
    <Box
      data-testid="datesFilterContainer"
      sx={{ display: { xs: 'flex', sm: 'block' }, flexDirection: { xs: 'column', sm: 'row' } }}
    >
      <AdvancedDateTimeInput
        {...props}
        maxDateTime={maxDateTime ?? (endDate && !maxDurationInDays ? parseDateAsDateTime(endDate) : undefined)}
        onChange={(newValue) => handleDateChange(newValue, startSource)}
        source={startSource}
      />
      <ArrowIcon
        sx={{
          width: 20,
          height: 20,
          margin: { xs: '4px auto -4px auto', sm: '18px 4px 0 4px' },
          transform: { xs: 'rotate(90deg)', sm: 'rotate(0deg)' },
          color: 'contrast',
        }}
      />
      <AdvancedDateTimeInput
        {...props}
        maxDateTime={maxDateTime}
        minDateTime={startDate && !maxDurationInDays ? parseDateAsDateTime(startDate) : undefined}
        onChange={(newValue) => handleDateChange(newValue, endSource)}
        source={endSource}
      />
    </Box>
  )
}
